define('Cart.Item.Summary.View.GiftWrap', [
    'underscore'
], function CartItemSummaryViewGiftWrap(
    _
) {
    'use strict';

    var isGiftWrapLine = function isGiftWrapLine(context) {
        var giftWrap = _(context.line.options).findWhere({ cartOptionId: 'custcol_giftwrap_line_id' }) || {};

        return giftWrap.value && giftWrap.value.internalid;
    };

    return {
        mountToApp: function mountToApp(container) {
            var layoutComponent = container.getComponent('Layout');

            layoutComponent.addToViewContextDefinition('Cart.Item.Summary.View', 'isGiftWrapLine', 'boolean', function isGiftWrapLn(context) {
                return isGiftWrapLine(context);
            });
        }
    };
});

